import { useCleanUserState } from '@/hooks/useCleanUserState.ts';
import React from 'react';
import { Button } from 'react-bootstrap';

const CleanUserStateButton: React.FC = () => {
  const { cleanUserState } = useCleanUserState();
  return (
    <Button className="absolute top-0 left-1/2 -translate-x-1/2" onClick={cleanUserState}>
      Clean user state DEV
    </Button>
  );
};

export default CleanUserStateButton;
